import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Stack } from '@famly/mf_layout_stack';
const DEFAULT_BADGE_SIZE = '48px';
const DEFAULT_BADGE_OFFSET = -8;
export const Badge = ({ zIndex = 0, offset = DEFAULT_BADGE_OFFSET, ...props }) => {
    const calculatedOffset = offset + props.index * 32 + DEFAULT_BADGE_OFFSET;
    return (_jsx(Stack, { backgroundColor: props.backgroundColor, width: DEFAULT_BADGE_SIZE, height: DEFAULT_BADGE_SIZE, borderRadius: "50%", alignItems: "center", justifyContent: "center", zIndex: zIndex, bottom: DEFAULT_BADGE_OFFSET, right: calculatedOffset, position: "absolute", borderWidth: "2px", borderStyle: "solid", border: props.borderColor, children: props.children }));
};
